import { ICatalogueContext } from "./types";

export const initialState: ICatalogueContext = {
	products: [],
	isLoading: false,
	errorMessage: "some Error",
};
